<template>
  <GlobalLoader
    :visible="globalLoaderVisible"
    :text="$t('Common.loading')"
  />
</template>

<script>
import globalLoader from 'mixins/globalLoader'

export default {
  name: 'CorpGlobalLoader',
  mixins: [globalLoader]
}
</script>
